
import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";


export const loadPermissions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        const shouldRefresh = !Array.isArray(state.permissionsByTeam) || state.permissionsByTeam.length === 0

        cacheManager.fetch('get/permissions', state.permissions, shouldRefresh)
            .then((response) => {
                if(!response.fromState) {
                    commit(types.ADD_PERMISSIONS, response.data.permissions)
                    commit(types.SET_PERMISSIONS_BY_TEAM, response.data.permissionsByTeam || [])
                }
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadAllPermissions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/sub/module/permission', state.all)
            .then((response) => {
                if(!response.fromState) commit(types.LOAD_PERMISSIONS, response.data)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })

}


